/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-18T11:02:58-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T17:17:23-07:00
*/

import React, { Component } from 'react';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import TextLink from '../../common/TextLink';
import Container from '../../blocks/Container';


class BlockedList extends Component {
  render() {
    return (
      <div>
        <Header>
          <div>
            <Headline>Blocked members</Headline>
            <Headline subhead>Blocked members can't see your profile or send you messages.</Headline>
          </div>
        </Header>
        <Container>
          <TextLink to="/blocked">View your blocked users.</TextLink>
        </Container>
      </div>
    );
  }
}

export default BlockedList;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/BlockedList.jsx